import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/common.css";

// 引入element-ui的样式
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./plugins/element.js";
Vue.use(ElementUI);
Vue.config.productionTip = false;
// 设置全局 URL
// Vue.prototype.$globalUrl = "http://120.46.64.98:83/prod-api";
// Vue.prototype.$globalIMG = "http://120.46.64.98:83/prod-api";

Vue.prototype.$globalUrl = window.location.origin + "/bjzsgxgc/prod-api";
Vue.prototype.$globalIMG = window.location.origin + "/bjzsgxgc/prod-api";
Vue.prototype.$globalIMG2 = window.location.origin;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
